module.exports = __webpack_public_path__ + "img/C03TechPVPGoldMine_ua.2946d68a.webp";